import React from "react";
import FashionTillShell from "./FashionTillShell";
import { formatTillMoney, formatTillAmount, tillAmountValue } from "./tillFormat";

const isBlank = (value) => value === "" || value === null || value === undefined || Number.isNaN(parseFloat(value));

// Board close-pay: step 2 of close till — check each payment type.
const FashionClosePayments = ({
  outlet,
  till,
  day,
  currency,
  payments = [],
  isEditable,
  showExpected,
  showDifference,
  billsCount,
  salesAmount,
  expectedTotal,
  countedTotal,
  noteValue,
  setNoteValue,
  onFieldInput,
  onFieldOut,
  onNext,
  onBack,
  confirmBtnRef,
  cancelBtnRef,
}) => {
  const pending = payments.filter((p) => isEditable(p) && isBlank(p.amount)).length;
  const meta = [till, outlet, day].filter(Boolean).join(" · ");
  return (
    <FashionTillShell title="Close till" meta={meta} onBack={onBack} step={2} testId="fashion-close-payments">
      <section className="ftill-main">
        <div>
          <h1 className="ftill-h1">Check each payment type</h1>
          <p className="ftill-sub">Card and UPI come from the terminal settlement. Enter credit sales from the credit register.</p>
        </div>
        <table className="ftill-table">
          <thead>
            <tr>
              <th>Payment type</th>
              <th className="ftill-num">Bills</th>
              {showExpected ? <th className="ftill-num">Expected</th> : null}
              <th className="ftill-num">Counted / settled</th>
              {showDifference ? <th className="ftill-num">Difference</th> : null}
            </tr>
          </thead>
          <tbody>
            {payments.map((payment) => {
              const editable = isEditable(payment);
              const blank = isBlank(payment.amount);
              const diff = Math.round(tillAmountValue(payment.difference) * 100) / 100;
              return (
                <tr key={payment.name}>
                  <td>
                    <b>{payment.name}</b>
                  </td>
                  <td className="ftill-num">{payment.transactionCount ?? 0}</td>
                  {showExpected ? <td className="ftill-num">{formatTillAmount(Math.max(tillAmountValue(payment.expectedAmount), 0))}</td> : null}
                  <td className="ftill-num ftill-num--cell">
                    {editable ? (
                      <input
                        className="ftill-input ftill-input--cell"
                        aria-label={`${payment.name} counted`}
                        type="number"
                        name={`${payment.name}`}
                        value={blank ? "" : payment.amount}
                        placeholder="0.00"
                        onChange={onFieldInput}
                        onBlur={onFieldOut}
                      />
                    ) : (
                      formatTillAmount(payment.amount)
                    )}
                  </td>
                  {showDifference ? (
                    <td className="ftill-num">
                      {editable && blank ? (
                        <span className="ftill-pill ftill-pill--muted">Enter amount</span>
                      ) : diff === 0 ? (
                        <span className="ftill-pill ftill-pill--ok">Matches</span>
                      ) : (
                        <span className={`ftill-pill ftill-pill--${diff < 0 ? "bad" : "warn"}`}>{formatTillMoney(diff, currency, { signed: true })}</span>
                      )}
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
      <aside className="ftill-side">
        <div className="ftill-rows">
          <div className="ftill-row">
            <span>Bills</span>
            <b>{billsCount ?? 0}</b>
          </div>
          <div className="ftill-row">
            <span>Sales</span>
            <b>{formatTillMoney(salesAmount, currency)}</b>
          </div>
          {showExpected ? (
            <div className="ftill-row">
              <span>Expected total</span>
              <b>{formatTillMoney(Math.max(tillAmountValue(expectedTotal), 0), currency)}</b>
            </div>
          ) : null}
          <div className="ftill-row ftill-row--total">
            <span>Counted total</span>
            <b>{formatTillMoney(countedTotal, currency)}</b>
          </div>
        </div>
        {pending > 0 ? (
          <div className="ftill-warn" role="status">
            {pending === 1 ? "1 payment type still needs an amount." : `${pending} payment types still need an amount.`}
          </div>
        ) : null}
        <div className="ftill-field">
          <label className="ftill-label" htmlFor="ftill-close-note">
            Note
          </label>
          <input id="ftill-close-note" className="ftill-input" value={noteValue} onChange={(e) => setNoteValue(e.target.value)} />
        </div>
        <div className="ftill-grow" />
        <div className="ftill-actions">
          <button type="button" ref={cancelBtnRef} className="ftill-btn ftill-btn--secondary" onClick={onBack}>
            Back
          </button>
          <button type="button" ref={confirmBtnRef} className="ftill-btn ftill-btn--primary" onClick={onNext}>
            Next: close
          </button>
        </div>
      </aside>
    </FashionTillShell>
  );
};

export default FashionClosePayments;
